import { images } from "../../constants";
 
const brandsData = [
  {id: 10, brand:'gps',imgUrl: images.gps},
  {id: 11, brand:'dsa',imgUrl: images.dsa},
  {id: 12, brand:'ura',imgUrl: images.ura},
  {id: 13, brand:'aaif',imgUrl: images.aaif},
  {id: 9, brand:'vital',imgUrl: images.vital},
  {id: 1, brand:'Scoolj Institute',imgUrl: images.si},
  {id: 2, brand:'bp',imgUrl: images.bp},
  {id: 3, brand:'Unilag Consult',imgUrl: images.unilagConsult},
  {id: 4, brand:'drill',imgUrl: images.drill},
  {id: 5, brand:'Scoolj Dot',imgUrl: images.scooljdot},
  {id: 6, brand:'bomi',imgUrl: images.bomi},
  {id: 7, brand:'pdt',imgUrl: images.pdt},
  {id: 8, brand:'sm',imgUrl: images.sm},
 
  ]
  export default brandsData;
 